<template>
  <div class="container">
    <CommonTitle :titleName="'报名'" bcColor="#f7f8fc" />
    <img
      class="bgk"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/mockSignLs/mock_sign_bgk.png"
      alt
    />
    <div class="content">
      <img
        class="area_icon"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/mockSignLs/mock_sign_area.png"
        alt
      />
      <div class="area_tip">所在地区</div>
      <div class="area_input_box" @click="openSelArea">
        <div class="area_input_tip">{{areaSelectedStr.length === 2 ? '点击选择省市区' : areaSelectedStr}}</div>
        <img
          class="area_icon_right"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/mockSignLs/mock_sign_sel.png"
          alt
        />
      </div>
    </div>
    <div class="stepOneBtn" @click="onTwo">查询考点</div>

    <div class="shadow" v-show="areaVisible">
      <div class="sel_area_modal" v-show="areaVisible">
        <!-- <div class="sel_area_top">
          <div class="sel_area_cancel">取消</div>
          <div class="sel_area_title">选择地区</div>
          <div class="sel_area_submit">确认</div>
        </div>-->
        <div class="sel_area_list">
          <van-picker
            title="选择地区"
            visible-item-count="4"
            show-toolbar
            :columns="areaColumns"
            @confirm="onAreaConfirm"
            @cancel="areaVisible = false"
            @change="onAreaChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { getRegisTrationList } from '@/api/registration';
import { getRegisterSourceInfo, isminiLogin } from '@/utils/tools';
import { mapState } from 'vuex';

export default {
  components: {
    CommonTitle,
  },
  data() {
    return {
      selectedArea: {
        province: '',
        city: '',
        district: '',
      },

      areaColumns: [],

      dataSource: [],

      examMap: {},

      areaVisible: false,
    };
  },
  computed: {
    areaSelectedStr() {
      return `${this.selectedArea.province}-${this.selectedArea.city}-${this.selectedArea.district}`;
    },
    ...mapState(['userInfo']),
  },
  methods: {
    openSelArea() {
      this.areaVisible = true;
    },

    onAreaConfirm(value) {
      console.log('value', value);
      this.selectedArea = {
        province: value[0],
        city: value[1],
        district: value[2],
      };
      this.areaVisible = false;
    },

    onTwo() {
      if (this.areaSelectedStr.length === 2) {
        this.$toast('请先选择地区~');
        return;
      }
      console.log(this.examMap[this.areaSelectedStr], '???');
      sessionStorage.setItem(
        'REGISTRATION_DISTRICTLIST',
        JSON.stringify(this.examMap[this.areaSelectedStr]),
      );
      this.$router.push({
        path: '/registrationTwo',
      });
    },

    onAreaChange(dom, values, index) {
      console.log('dom', dom, values, index);
      if (index === 0) {
        this.initArea(values[0]);
      }
      if (index === 1) {
        let districtList = new Set();
        this.dataSource.forEach(item => {
          if (item.province === values[0] && item.city === values[1]) {
            districtList.add(item.district);
          }
        });
        this.areaColumns = [
          this.areaColumns[0],
          this.areaColumns[1],
          {
            values: Array.from(districtList),
          },
        ];
      }
    },

    getList() {
      getRegisTrationList().then(res => {
        console.log('res', res);
        this.dataSource = res.map(item => {
          const { province, city, district } = item;
          return {
            ...item,
            province: province?.trim(),
            city: city?.trim(),
            district: district?.trim(),
          };
        });
        this.initArea();
      });
    },

    initArea(defProvince) {
      if (!defProvince) {
        this.selectedAre = {
          province: '',
          city: '',
          district: '',
        };
      }

      const provinceList = new Set();
      const cityList = new Set();
      const districtList = new Set();

      const examMap = {};

      let initProvince = this.dataSource[0].province;
      let initCity = this.dataSource[0].city;

      if (defProvince) {
        initProvince = defProvince;
        initCity = null;
      }

      this.dataSource.forEach(item => {
        const { province, city, district } = item;

        provinceList.add(province);

        if (defProvince === province && !initCity) {
          initCity = city;
        }

        if (province === initProvince) {
          cityList.add(city);
        }
        if (city === initCity) {
          districtList.add(district);
        }

        const key = `${province}-${city}-${district}`;

        if (examMap[key]) {
          examMap[key].push(item);
        } else {
          examMap[key] = [item];
        }
      });

      this.areaColumns = [
        {
          values: Array.from(provinceList),
        },
        {
          values: Array.from(cityList),
        },
        {
          values: Array.from(districtList),
        },
      ];
      this.examMap = examMap;
      console.log('areaColumns', this.areaColumns);
    },
  },
  mounted() {
    if (!this.userInfo.id) {
      const { isApp = false } = this.$root.$data;
      if (isApp) {
        getRegisterSourceInfo(this, 'registration', 2, false);
      } else if (this.$root.whatEev === 'miniprogram') {
        let url = window.location.href;
        isminiLogin(url);
      } else {
        const { search } = window.location;
        const has = search !== '';
        const param = { has, redirect: '/registration' };
        this.$router.push({ path: '/registrationLogin', query: param });
      }
      return;
    }

    this.getList();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-picker__confirm {
  font-weight: 500;
  color: #ff7f41;
}

.container {
  background: #f7f8fc;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  font-family: PingFangSC, PingFang SC;

  .bgk {
    height: 703px;
    width: 750px;
    display: block;
    margin-top: 100px;
  }
  .content {
    position: relative;
    width: 678px;
    height: 243px;
    background: #ffffff;
    box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.03);
    border-radius: 14px;
    margin: -89px auto 0;
    padding: 43px 29px;

    .area_icon {
      float: left;
      height: 51px;
      width: 51px;
      display: block;
    }

    .area_tip {
      float: left;
      height: 51px;
      font-weight: 500;
      font-size: 29px;
      color: #333333;
      line-height: 51px;
      margin-left: 14px;
    }
    .area_input_box {
      float: left;
      width: 620px;
      height: 72px;
      background: #f7f8fc;
      border-radius: 11px;
      margin-top: 25px;
      display: flex;
      align-items: center;
      padding: 0 29px;
      justify-content: space-between;

      .area_input_tip {
        height: 36px;
        font-weight: 400;
        font-size: 25px;
        color: #999999;
        line-height: 36px;
      }

      .area_icon_right {
        height: 24px;
        width: 13px;
      }
    }
  }

  .stepOneBtn {
    position: fixed;
    left: 36px;
    bottom: 65px;
    width: 678px;
    height: 80px;
    background: #ff7f41;
    border-radius: 45px;
    font-weight: 500;
    font-size: 29px;
    color: #ffffff;
    line-height: 80px;
    text-align: center;
  }

  .shadow {
    position: fixed;
    z-index: 10001;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);

    .sel_area_modal {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 750px;
      height: 609px;
      background: #ffffff;
      border-radius: 36px 36px 0px 0px;
      padding-top: 49px;
      padding-bottom: 30px;

      .sel_area_top {
        height: 45px;
        width: 678px;
        margin: 54px auto 0;
        line-height: 45px;
        display: flex;
        justify-content: space-between;

        .sel_area_cancel {
          font-weight: 400;
          font-size: 29px;
          color: #333333;
        }
        .sel_area_title {
          font-weight: 500;
          font-size: 33px;
          color: #333333;
        }
        .sel_area_submit {
          font-weight: 500;
          font-size: 29px;
          color: #ff7f41;
        }
      }

      .sel_area_list {
        height: 312px;
      }
    }
  }
}
</style>